export const config = {
    sso_client_id: process.env.REACT_APP_SSO_CLIENT_ID || 'N/A',
    sso_auth_url: process.env.REACT_APP_SSO_AUTH_URL || 'N/A',
    easycrm_url: process.env.REACT_APP_EASYCRM_URL || 'N/A',
    easywebinar_url: process.env.REACT_APP_EASYWEBINAR_URL || 'N/A',
    auth_app_url: process.env.REACT_APP_AUTH_APP_URL || 'N/A',
    easywebinar_v2_url: process.env.REACT_APP_EASYWEBINAR_V2_URL || 'N/A',
    chargebee_publishableKey: process.env.REACT_APP_CHARGEBEE_PUBLISHABLE_KEY || 'N/A',
    chargebee_site: process.env.REACT_APP_CHARGEBEE_SITE || 'N/A',
    auth_api_url: process.env.REACT_APP_AUTH_API_BASE_URL || 'N/A',
    env: process.env.REACT_APP_ENV || 'N/A',
    mixpanel_project_token: process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN || '',
    easywebinar_ai_url: process.env.REACT_APP_EASYWEBINAR_AI_URL || 'N/A',
    // Sale configuration - can be controlled via environment variable
    monthlyCouponCode: "HALO30",
    yearlyCouponCode: "HALO50",
    isSaleLive: false,
    isPromontionBannerLive: (() => {
        // isPromontionBannerLive = true until october 8th , 11am PST 2025
        // Set the cutoff date: October 8th, 11am PST 2025
        const cutoffDate = new Date('2025-10-08T11:00:00-08:00'); // PST timezone
        const now = new Date();
        return now < cutoffDate;
    })(),
}